<template>
  <v-dialog v-model="dialogComputed" max-width="1000px" persistent>
    <v-card>
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0527') }} <span v-if="headerTitle">&nbsp;({{ headerTitle }})</span>
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed right iconProp color="white" />
      </v-card-title>
      <div>
        <v-row class="ma-0">
          <v-col class="col-6 d-flex align-center justify-center">
            <v-progress-circular v-if="loadingComputed" indeterminate size="64"></v-progress-circular>
            <v-img
              v-else-if="fileUrlComputed"
              class="pa-0 ma-0"
              style="height: 600px"
              contain
              :src="fileUrlComputed"
              @click="imageDialog = true"
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </div>
              </template>
            </v-img>
            <v-card-title v-else class="d-flex align-center justify-center">
              {{ $t('MSG0174') }}
            </v-card-title>
          </v-col>
          <v-col class="col-6">
            <v-card outlined class="px-2 py-2">
              <v-row class="ma-0"> {{ $t('ELE0137') }}:&nbsp;{{ inspIndexNo }} </v-row>
              <v-row class="ma-0"> {{ $t('ELE0157') }}:&nbsp;{{ cav }} </v-row>
              <v-row class="ma-0"> {{ $t('ELE0098') }}:&nbsp;{{ numOfInsp }} </v-row>
            </v-card>
            <v-row class="ma-0 pl-2 mt-2 d-flex align-end bold">
              <v-card-title class="pa-0"> {{ $t('ELE0208') }} </v-card-title>
              <v-spacer />
              <Btn v-if="canEdit" class="mx-2" :label="$t('ELE0016')" @click="onClickAdd" :disabled="isInquiry" />
            </v-row>
            <v-card outlined class="mt-2">
              <v-data-table
                :headers="headersAttach"
                :items="fileComputed"
                disable-pagination
                hide-default-footer
                mobile-breakpoint="0"
                fixed-header
                height="400px"
                dense
              >
                <template v-slot:[`item.action`]="{ item, index }">
                  <td class="px-2 v-data-table__divider">
                    <div class="d-flex" style="width: 96px">
                      <div class="pa-0 px-1 col-4">
                        <IconView v-if="isFileFormatViewable(item)" @click="onClickView(item)" />
                      </div>
                      <div class="pa-0 px-1 col-4">
                        <IconDownload v-if="isFileDownloadable(item)" @click="onClickDownload(item)" />
                      </div>
                      <div class="pa-0 px-1 col-4">
                        <IconDelete :disabled="isInquiry" @click="onDeleteAttach(index)" />
                      </div>
                    </div>
                  </td>
                </template>
                <template v-slot:[`item.docTitle`]="{ item }">
                  {{ item.title }}
                </template>
                <template v-slot:[`item.filePath`]="{ item }">
                  {{ item.filename }}
                </template>
              </v-data-table>
            </v-card>
            <v-row v-if="canEdit" class="ma-0 justify-end pt-4">
              <Btn class="mx-2" :label="$t('ELE0105')" @click="onSet" :disabled="isInquiry" />
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog v-if="fileUrlComputed" v-model="imageDialog" width="auto">
      <v-card class="d-flex align-center justify-center" width="100%" style="min-height: 50vh; max-width: 90vw">
        <img
          height="100%"
          width="100%"
          style="min-height: inherit"
          v-if="fileUrlComputed"
          class="pa-0 ma-0"
          :src="fileUrlComputed"
          @click="onClickCloseImage"
        />
      </v-card>
    </v-dialog>
    <FileUploadDialog :dialog.sync="displayAddDialog" @change="onFileAdd" />
  </v-dialog>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import IconDelete from '@/components/atoms/icon/IconDelete'
import IconView from '@/components/atoms/icon/IconView'
import IconDownload from '@/components/atoms/icon/IconDownload'
import FileUploadDialog from '@/components/organisms/terminal/dialog/FileUploadDialog'
import FileView from '@/components/organisms/common/preview/FileView'
import { Storage } from '@/plugins/storage'

export default {
  name: 'InspectionFileAttachmentDialog',

  components: { Btn, TextFieldInput, TextFieldRef, IconDelete, IconView, IconDownload, FileUploadDialog, FileView },

  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: true,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    attachedFiles: {
      type: Array,
      required: true,
      default: () => [],
    },
    inspIndexNo: {
      type: String,
      required: true,
    },
    cav: {
      type: String,
      required: true,
    },
    numOfInsp: {
      type: Number,
      required: true,
    },
    headerTitle: {
      type: String,
      required: false,
    },
    isInquiry: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    fileComputed: {
      get() {
        return this.fileAttachments
      },
      set(value) {
        this.fileAttachments = value
      },
    },
    fileUrlComputed: {
      get() {
        return this.fileUrl
      },
      set(value) {
        this.fileUrl = value
      },
    },
    loadingComputed: {
      get() {
        return this.loading
      },
      set(value) {
        this.loading = value
      },
    },
  },
  methods: {
    close() {
      this.fileAttachments = []
      this.dialogComputed = false
    },
    onDeleteAttach(index) {
      this.fileAttachments.splice(index, 1)
    },
    onClickAdd() {
      this.displayAddDialog = true
    },
    onFileAdd(fileDetail) {
      this.fileAttachments = [
        ...this.fileAttachments,
        {
          title: fileDetail.title,
          filename: fileDetail.file.name,
          file: fileDetail.file,
          filePath: '',
        },
      ]
    },
    onSet() {
      this.$emit('set', this.fileAttachments)
      this.dialogComputed = false
    },
    isFileFormatViewable(fileDetail) {
      let fileExt = fileDetail.filePath.substr(fileDetail.filePath.lastIndexOf('.') + 1)
      fileExt = fileExt.toLowerCase()
      if (this.imageFormats.includes(fileExt)) {
        return true
      }
    },
    isFileDownloadable(fileDetail) {
      return fileDetail.filePath != ''
    },
    async onClickView(fileDetail) {
      this.loadingComputed = true
      this.fileUrlComputed = await Storage.getFileUrl(fileDetail.filePath)
      this.loadingComputed = false
    },
    onClickCloseImage() {
      // this.fileUrlComputed = null
      this.imageDialog = false
    },
    onClickDownload(fileDetail) {
      Storage.downloadFile(fileDetail.filePath)
    },
  },

  data() {
    return {
      fileUrl: '',
      displayAddDialog: false,
      fileAttachments: [],
      headersAttach: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        { text: this.$t('ELE0241'), value: 'docTitle', divider: true, sortable: false },
        { text: this.$t('ELE0035'), value: 'filePath', sortable: false },
      ],
      imageFormats: ['png', 'jpg', 'jpeg'],
      imageDialog: false,
      loading: false,
    }
  },
  mounted() {
    this.fileComputed = [...this.attachedFiles] //参照の代わりに値をコピーする
  },
}
</script>
